import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';
import { Stores } from '../../interfaces/stores';

@Component({
  selector: 'app-list-store',
  templateUrl: './list-store.component.html',
  styleUrls: ['./list-store.component.css']
})
export class ListStoreComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,

  ) { }
  facilityes: Facility[];
  view: number = 1;
  status: any;
  categorys: any;
  idSelected: number = 0;
  ngOnInit(): void {
    this.getData();
    this.get();
  }

  items: Stores[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  form = new UntypedFormGroup({
    facility_id: new UntypedFormControl(0),
    q:new UntypedFormControl(''),
  });
  formDelete = new UntypedFormGroup({
    id: new UntypedFormControl()
  });
  delete() {
    this.api.deleteStore(this.formDelete).subscribe(
      (response) => {
        this.toast.success(
          'Dependencias eliminada correctamente',
          'Gestión dependencias'
        );
        this.modal.dismissAll();
        this.get();
      },
      (e) => {
        
        this.toast.warning(e.error.mistakes,e.error.msg);
      }
    );
  }
  goToUpdate(id: number) {
    console.log("LLEGO A BODEGA");
    this.router.navigate(['control-ingreso/dependencias/editar/' + id]);
  }
  getData() {
    this.api.getAllFacility().subscribe(
      (response) => {
        this.facilityes = response.data as Facility[];
      }
    );
  }
  get() {
    this.api.paginateStore(this.page,this.form).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as Stores[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
      },
      (e) => {
        this.items = [];
        this.page = 1;
        this.collectionSize=0;
        this.totalPage=0;
      }
    );
  }
  openModal(md: any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openDelete(id: number, md: any) {
    this.formDelete.get('id').setValue(id);
    this.modal.open(md, {
      size: 'md',
    });
  }
  clean(){
    this.form.get('q').setValue('');
    this.page=1;
    this.get();
  }
  search(q:string='') {
    if(q.length>=2){
      this.form.get('q').setValue(q);
      console.log('result q:',q);
      this.page=1;
    }
    this.get();
  }
}

